import { render, staticRenderFns } from "./Homestay.vue?vue&type=template&id=6a58743e&scoped=true&"
import script from "./Homestay.vue?vue&type=script&lang=js&"
export * from "./Homestay.vue?vue&type=script&lang=js&"
import style0 from "./Homestay.vue?vue&type=style&index=0&id=6a58743e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58743e",
  null
  
)

export default component.exports